import ProposalPagination from 'app/components/proposal/Pagination'
import {changeLimit, changePage} from 'app/modules/States/redux'
import * as selectors from 'app/modules/States/redux/selectors'
import React from 'react'
import {useSelector} from 'react-redux'

import TableHead from './Header'
import TableRow from './Row'
import SkeletonRow from './Row/skeleton'

const SKELETON_ITEMS = 10

const ListTable = ({limit, loading, page, total, states}) => {
  const columns = useSelector(selectors.getStatesColumns)

  const renderState = (state) => <TableRow key={`k=${state.id}`} {...state} columns={columns} />

  return (
    <div className="container-citymatch-table">
      <div className="table-responsive" style={{overflowX: 'auto'}}>
        <table className="table">
          <TableHead />
          <tbody>
            {loading
              ? Array.from({length: SKELETON_ITEMS}).map((_, index) => <SkeletonRow key={index} />)
              : states?.map(renderState)}
          </tbody>
        </table>
      </div>
      <ProposalPagination
        actualLenght={states.length}
        limit={limit}
        loading={loading}
        page={page}
        total={total}
        changePage={changePage}
        changeLimit={changeLimit}
      />
    </div>
  )
}

export default ListTable
